(function () {
  function cleanEmptyPriceParams() {
    var url = new URL(window.location.href);
    var changed = false;

    ["filter.v.price.gte", "filter.v.price.lte"].forEach(function (paramName) {
      if (
        url.searchParams.has(paramName) &&
        url.searchParams.get(paramName) === ""
      ) {
        url.searchParams.delete(paramName);
        changed = true;
      }
    });

    if (changed) {
      window.location.replace(url.toString());
      return true;
    }

    return false;
  }

  function initTuyaProductCatalog(section) {
    if (!section || section.dataset.tuyaCatalogReady === "true") return;

    if (cleanEmptyPriceParams()) return;

    section.dataset.tuyaCatalogReady = "true";

    const forms = section.querySelectorAll("[data-tuya-catalog-form]");
    const filterToggle = section.querySelector(
      "[data-tuya-catalog-filter-toggle]",
    );
    const filterCloseButtons = section.querySelectorAll(
      "[data-tuya-catalog-filter-close]",
    );
    const overlay = section.querySelector("[data-tuya-catalog-overlay]");
    const sidebar = section.querySelector(".tuya-product-catalog__sidebar");
    const viewButtons = section.querySelectorAll("[data-tuya-catalog-view]");
    const results = section.querySelector("[data-tuya-catalog-results]");
    const sortControls = section.querySelectorAll("[data-tuya-catalog-sort]");

    function updateFilterPanelHeight() {
      if (!sidebar || window.matchMedia("(min-width: 990px)").matches) return;

      var sidebarTop = Math.max(sidebar.getBoundingClientRect().top, 0);
      sidebar.style.setProperty(
        "--tuya-product-catalog-filter-panel-top",
        Math.ceil(sidebarTop) + "px",
      );
    }

    function updateSortMenuHeight(control) {
      if (!control || window.matchMedia("(min-width: 990px)").matches) return;

      var menu = control.querySelector("[data-tuya-catalog-sort-menu]");
      if (!menu) return;

      var menuTop = Math.max(menu.getBoundingClientRect().top, 0);
      menu.style.setProperty(
        "--tuya-product-catalog-sort-menu-top",
        Math.ceil(menuTop) + "px",
      );
    }

    function setFiltersOpen(isOpen) {
      if (isOpen) {
        updateFilterPanelHeight();
      }

      section.classList.toggle("is-filters-open", isOpen);
      document.documentElement.classList.toggle("tuya-catalog-lock", isOpen);
      if (filterToggle) {
        filterToggle.setAttribute("aria-expanded", String(isOpen));
      }
    }

    if (filterToggle) {
      filterToggle.addEventListener("click", function () {
        setFiltersOpen(!section.classList.contains("is-filters-open"));
      });
    }

    filterCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setFiltersOpen(false);
      });
    });

    if (overlay) {
      overlay.addEventListener("click", function () {
        setFiltersOpen(false);
      });
    }

    section.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setFiltersOpen(false);
      }
    });

    forms.forEach(function (form) {
      const autoSubmitElements = form.querySelectorAll(
        "[data-tuya-catalog-auto-submit]",
      );

      form.addEventListener("submit", function () {
        form
          .querySelectorAll(
            "[data-tuya-price-hidden-min], [data-tuya-price-hidden-max]",
          )
          .forEach(function (input) {
            input.disabled = input.value === "";
          });
      });

      autoSubmitElements.forEach(function (element) {
        element.addEventListener("change", function () {
          form.requestSubmit();
        });
      });
    });

    function closeSortControl(control) {
      if (!control) return;

      const button = control.querySelector("[data-tuya-catalog-sort-button]");
      control.classList.remove("is-open");

      if (button) {
        button.setAttribute("aria-expanded", "false");
      }
    }

    function closeAllSortControls(exceptControl) {
      sortControls.forEach(function (control) {
        if (control !== exceptControl) {
          closeSortControl(control);
        }
      });
    }

    sortControls.forEach(function (control) {
      const button = control.querySelector("[data-tuya-catalog-sort-button]");
      const select = control.querySelector("[data-tuya-catalog-sort-select]");
      const valueLabel = control.querySelector(
        "[data-tuya-catalog-sort-value]",
      );
      const options = control.querySelectorAll(
        "[data-tuya-catalog-sort-option]",
      );
      const form = control.closest("form");

      if (!button || !select || !options.length || !form) return;

      function setOpen(isOpen) {
        closeAllSortControls(control);
        control.classList.toggle("is-open", isOpen);
        button.setAttribute("aria-expanded", String(isOpen));

        if (isOpen) {
          updateSortMenuHeight(control);
        }
      }

      button.addEventListener("click", function () {
        setOpen(!control.classList.contains("is-open"));
      });

      button.addEventListener("keydown", function (event) {
        if (
          event.key === "ArrowDown" ||
          event.key === "Enter" ||
          event.key === " "
        ) {
          event.preventDefault();
          setOpen(true);
          options[0].focus();
        }
      });

      options.forEach(function (option, index) {
        option.addEventListener("click", function () {
          const value = option.dataset.tuyaCatalogSortOptionValue;
          if (!value) return;

          select.value = value;

          if (valueLabel) {
            valueLabel.textContent = option.textContent.trim();
          }

          options.forEach(function (item) {
            const isActive = item === option;
            item.classList.toggle("is-active", isActive);
            item.setAttribute("aria-selected", String(isActive));
          });

          closeSortControl(control);
          form.requestSubmit();
        });

        option.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            event.preventDefault();
            closeSortControl(control);
            button.focus();
          }

          if (event.key === "ArrowDown") {
            event.preventDefault();
            options[Math.min(index + 1, options.length - 1)].focus();
          }

          if (event.key === "ArrowUp") {
            event.preventDefault();
            options[Math.max(index - 1, 0)].focus();
          }
        });
      });
    });

    document.addEventListener("click", function (event) {
      if (section.classList.contains("is-filters-open")) {
        var isOutsideSidebar = sidebar && !sidebar.contains(event.target);
        var isOutsideToggle =
          !filterToggle || !filterToggle.contains(event.target);

        if (isOutsideSidebar && isOutsideToggle) {
          setFiltersOpen(false);
        }
      }

      if (!section.contains(event.target)) {
        closeAllSortControls();
        return;
      }

      sortControls.forEach(function (control) {
        if (!control.contains(event.target)) {
          closeSortControl(control);
        }
      });
    });

    window.addEventListener("resize", function () {
      if (section.classList.contains("is-filters-open")) {
        updateFilterPanelHeight();
      }

      sortControls.forEach(function (control) {
        if (control.classList.contains("is-open")) {
          updateSortMenuHeight(control);
        }
      });
    });

    if (viewButtons.length && results) {
      var savedView = localStorage.getItem("tuya-catalog-view");
      if (savedView) {
        results.dataset.tuyaCatalogResults = savedView;
        viewButtons.forEach(function (item) {
          var isCurrent = item.dataset.tuyaCatalogView === savedView;
          item.classList.toggle("is-active", isCurrent);
          item.setAttribute("aria-pressed", String(isCurrent));
        });
      }

      viewButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var view = button.dataset.tuyaCatalogView;
          if (!view) return;

          results.dataset.tuyaCatalogResults = view;
          localStorage.setItem("tuya-catalog-view", view);

          viewButtons.forEach(function (item) {
            var isCurrent = item === button;
            item.classList.toggle("is-active", isCurrent);
            item.setAttribute("aria-pressed", String(isCurrent));
          });
        });
      });
    }

    /* Price range slider */
    var priceRanges = section.querySelectorAll("[data-tuya-price-range]");
    priceRanges.forEach(function (container) {
      var thumbMin = container.querySelector("[data-tuya-price-thumb-min]");
      var thumbMax = container.querySelector("[data-tuya-price-thumb-max]");
      var inputMin = container.querySelector("[data-tuya-price-input-min]");
      var inputMax = container.querySelector("[data-tuya-price-input-max]");
      var hiddenMin = container.querySelector("[data-tuya-price-hidden-min]");
      var hiddenMax = container.querySelector("[data-tuya-price-hidden-max]");
      var fill = container.querySelector("[data-tuya-price-fill]");

      if (
        !thumbMin ||
        !thumbMax ||
        !inputMin ||
        !inputMax ||
        !hiddenMin ||
        !hiddenMax ||
        !fill
      )
        return;

      var rangeMin = parseInt(container.dataset.rangeMin, 10);
      var rangeMax = parseInt(container.dataset.rangeMax, 10);

      function getIntegerValue(input, fallback) {
        var value = parseInt(input.value, 10);
        return Number.isFinite(value) ? value : fallback;
      }

      function setPriceValues(min, max) {
        inputMin.value = min > rangeMin ? min : "";
        inputMax.value = max < rangeMax ? max : "";
        hiddenMin.value = min > rangeMin ? min : "";
        hiddenMax.value = max < rangeMax ? max : "";
      }

      function updateFill() {
        if (rangeMax <= rangeMin) {
          fill.style.left = "0%";
          fill.style.width = "100%";
          return;
        }

        var min = getIntegerValue(thumbMin, rangeMin);
        var max = getIntegerValue(thumbMax, rangeMax);
        var leftPercent = ((min - rangeMin) / (rangeMax - rangeMin)) * 100;
        var rightPercent = ((max - rangeMin) / (rangeMax - rangeMin)) * 100;
        fill.style.left = leftPercent + "%";
        fill.style.width = rightPercent - leftPercent + "%";
      }

      function syncFromThumbs() {
        setPriceValues(
          getIntegerValue(thumbMin, rangeMin),
          getIntegerValue(thumbMax, rangeMax),
        );
      }

      function onThumbMinInput() {
        var min = getIntegerValue(thumbMin, rangeMin);
        var max = getIntegerValue(thumbMax, rangeMax);
        if (min > max) thumbMin.value = max;
        updateFill();
        syncFromThumbs();
      }

      function onThumbMaxInput() {
        var min = getIntegerValue(thumbMin, rangeMin);
        var max = getIntegerValue(thumbMax, rangeMax);
        if (max < min) thumbMax.value = min;
        updateFill();
        syncFromThumbs();
      }

      function onInputMinChange() {
        var val = inputMin.value
          ? getIntegerValue(inputMin, rangeMin)
          : rangeMin;
        val = Math.max(
          rangeMin,
          Math.min(val, getIntegerValue(thumbMax, rangeMax)),
        );
        thumbMin.value = val;
        setPriceValues(val, getIntegerValue(thumbMax, rangeMax));
        updateFill();
      }

      function onInputMaxChange() {
        var val = inputMax.value
          ? getIntegerValue(inputMax, rangeMax)
          : rangeMax;
        val = Math.min(
          rangeMax,
          Math.max(val, getIntegerValue(thumbMin, rangeMin)),
        );
        thumbMax.value = val;
        setPriceValues(getIntegerValue(thumbMin, rangeMin), val);
        updateFill();
      }

      thumbMin.addEventListener("input", onThumbMinInput);
      thumbMax.addEventListener("input", onThumbMaxInput);
      inputMin.addEventListener("change", onInputMinChange);
      inputMax.addEventListener("change", onInputMaxChange);
      updateFill();
    });

    const activeCategories = section.querySelectorAll(
      ".tuya-catalog-categories__item.is-active",
    );
    activeCategories.forEach(function (item) {
      item.classList.add("is-open");
      const arrow = item.querySelector(".tuya-catalog-categories__arrow");
      if (arrow && arrow.dataset.collapseLabel) {
        arrow.setAttribute("aria-expanded", "true");
        arrow.setAttribute("aria-label", arrow.dataset.collapseLabel);
      }
    });

    const categoryArrows = section.querySelectorAll(
      ".tuya-catalog-categories__arrow",
    );
    categoryArrows.forEach(function (arrow) {
      arrow.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const item = arrow.closest(".tuya-catalog-categories__item");
        if (item) {
          const isExpanded = arrow.getAttribute("aria-expanded") === "true";
          arrow.setAttribute("aria-expanded", String(!isExpanded));
          item.classList.toggle("is-open", !isExpanded);

          const expandLabel = arrow.dataset.expandLabel;
          const collapseLabel = arrow.dataset.collapseLabel;
          if (expandLabel && collapseLabel) {
            arrow.setAttribute("aria-label", !isExpanded ? collapseLabel : expandLabel);
          }
        }
      });
    });
  }

  function initAllTuyaProductCatalogs() {
    document
      .querySelectorAll('[data-tuya-section="product-catalog"]')
      .forEach(initTuyaProductCatalog);
  }

  document.addEventListener("DOMContentLoaded", initAllTuyaProductCatalogs);

  document.addEventListener("shopify:section:load", function (event) {
    initTuyaProductCatalog(
      event.target.querySelector('[data-tuya-section="product-catalog"]') ||
        event.target,
    );
  });

  document.addEventListener("shopify:section:unload", function () {
    document.documentElement.classList.remove("tuya-catalog-lock");
  });
})();
